import React from 'react';
import AddReferenceModal from './AddReferenceModal';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import Select from '../../commonComponents/util/Select';
import Toggle from '../../commonComponents/util/Toggle';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';

const ReferencesTable = ({ references, removeReference, type }) => (
    (references && references.length > 0) ? (
        <div className="details-card-rows">
            {references.map(reference =>
                <div className="flex" key={reference.referenceId}>
                    <div className="flex">
                        {reference.displayName && <p className="small-text">
                            <i className="icons ion-ios-person-outline accent-text2" />
                            {reference.displayName}
                        </p>}
                        {reference.relationship && <p className="small-text">
                            <i className="icons ion-ios-information-outline accent-text2" />
                            {reference.relationship}
                        </p>}
                        {(reference.phoneNumber || reference.secondPhoneNumber) && <p className="small-text">
                            <i className="icons ion-ios-telephone-outline accent-text2" />
                            {[reference.phoneNumber, reference.secondPhoneNumber].filter(p => p).join(' | ')}
                        </p>}
                        {reference.email && <p className="small-text">
                            <i className="icons ion-ios-email-outline accent-text2" />
                            {reference.email}
                        </p>}
                        {reference.addressDisplay && <p className="small-text">
                            <i className="icons ion-ios-location-outline accent-text2" />
                            {reference.addressDisplay}
                        </p>}
                    </div>
                    <div className="flex">
                        {!reference.isUsedAsPayee && <span onClick={() => removeReference(reference.referenceId, type)} className="link-text">Remove</span>}
                    </div>
                </div>
            )}
        </div>
    ) : null
);

export default class RecipientReferencesTable extends NavigationComponent {

    constructor(props) {
        super(props);

        this.state = {
            newReferenceType: this.ReferenceTypes.Reference,
            showModals: {
                addReferenceModal: false
            }
        };
    }

    ReferenceTypes = {
        Reference: { type: "Reference", prop: "references" },
        Solicitor: { type: "Solicitor", prop: "solicitors" },
        RoshYeshiva: { type: "Rosh Yeshiva", prop: "roshYeshivas" }
    }

    addReference = async (reference) => {
        const referencesProp = this.state.newReferenceType.prop;
        const references = [...this.props[referencesProp], reference];
        this.props.updateRecipient(referencesProp, references);
    }

    removeReference = async (referenceId, referenceType) => {
        const referencesProp = referenceType.prop;

        const recipientUpdate = {
            [referencesProp]: this.props[referencesProp].filter(r => r.referenceId !== referenceId)
        };

        if (referenceType === this.ReferenceTypes.Reference) {
            if (this.props.trustedPayee && this.props.trustedPayee.referenceId === referenceId)
                recipientUpdate.trustedPayee = null;
            if (this.props.setTrustedPayee && !recipientUpdate.references.filter(ref => ref.isPayable).length)
                this.props.toggleSetTrustedPayee("setTrustedPayee", false);
        }

        this.props.updateRecipientProps(recipientUpdate);
    }

    toggleSetTrustedPayee = (name, value) => {
        this.props.toggleSetTrustedPayee(name, value);

        if (!value)
            this.selectTrustedPayee('trustedPayee', null);
    }

    selectTrustedPayee = (name, value) => {
        const trustedPayee = !value ? null :
            this.props.references[this.props.references.map(ref => ref.referenceId.toString()).indexOf(value.toString())] || null;
        this.props.updateRecipient(name, trustedPayee);
    }

    render() {
        const { className, references, solicitors, roshYeshivas, trustedPayee, setTrustedPayee, submitAttempted } = this.props;
        const { newReferenceType, showModals } = this.state;

        return (
            <div>
                <div>
                    <label className={className}>
                        References
                        <span
                            className="link-text"
                            onClick={() => {
                                this.setState({
                                    newReferenceType: this.ReferenceTypes.Reference
                                }, () => this.toggleModal("addReferenceModal"));
                            }}
                        >
                            Add New
                        </span>
                    </label>
                    <ReferencesTable
                        references={references}
                        removeReference={this.removeReference}
                        type={this.ReferenceTypes.Reference}
                    />
                    {(references && references
                        .filter(ref => ref.isPayable)
                        .length > 0) && (
                            <div className="flex-center trusted-payee">
                                <Toggle id="setTrustedPayee"
                                    disabled={trustedPayee ? trustedPayee.isUsedAsPayee : false}
                                    name="setTrustedPayee"
                                    value={setTrustedPayee}
                                    onChange={this.toggleSetTrustedPayee} />
                                <label className="small-text middle">Set Trusted Payee</label>

                                {setTrustedPayee && <ValidatedInput
                                    input={
                                        <Select
                                            tabIndex={this.props.tabIndex}
                                            disabled={trustedPayee ? trustedPayee.isUsedAsPayee : false}
                                            options={references
                                                .filter(ref => ref.isPayable)
                                                .map(ref => ({ key: ref.referenceId, value: ref.displayName }))}
                                        />
                                    }
                                    name="trustedPayee"
                                    value={trustedPayee ? trustedPayee.referenceId : null}
                                    onChange={this.selectTrustedPayee}
                                    required={setTrustedPayee}
                                    showRequiredError={submitAttempted}
                                />}
                            </div>
                        )
                    }
                </div>

                <div style={{ marginTop: "32px" }}>
                    <label className={className}>
                        Solicitors
                        <span
                            className="link-text"
                            onClick={() => {
                                this.setState({
                                    newReferenceType: this.ReferenceTypes.Solicitor
                                }, () => this.toggleModal("addReferenceModal"));
                            }}
                        >
                            Add New
                        </span>
                    </label>
                    <ReferencesTable
                        references={solicitors}
                        removeReference={this.removeReference}
                        type={this.ReferenceTypes.Solicitor}
                    />
                </div>

                <div style={{ marginTop: "32px" }}>
                    <label className={className}>
                        Rosh Yeshivas
                        <span
                            className="link-text"
                            onClick={() => {
                                this.setState({
                                    newReferenceType: this.ReferenceTypes.RoshYeshiva
                                }, () => this.toggleModal("addReferenceModal"));
                            }}
                        >
                            Add New
                        </span>
                    </label>
                    <ReferencesTable
                        references={roshYeshivas}
                        removeReference={this.removeReference}
                        type={this.ReferenceTypes.RoshYeshiva}
                    />
                </div>


                <AddReferenceModal
                    show={showModals.addReferenceModal}
                    close={() => this.toggleModal("addReferenceModal")}
                    referenceType={newReferenceType.type}
                    filterReferences={ref =>
                        [newReferenceType.prop]
                            .map(r => r.referenceId)
                            .indexOf(ref.referenceId) < 0
                    }
                    addReference={this.addReference} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applicationsCommon/RecipientReferencesTable.jsx